import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { toast } from 'react-toastify';
import apiConfig from 'constants/apiConfig';
import { keys } from 'components/IncidentConfig/hooks/useGetIncidentPositionInfo';
import { useOptionalCreateRosterDraft } from 'components/IncidentConfig/CreateIncident/CreateRosterDraftContext';

interface UpdatePositionAndRoleParams {
  incidentId: string;
  position: {
    id: string;
    name: string;
  };
  permissions: {
    id: string;
  }[];
}

export const useUpdatePositionAndRole = () => {
  const draft = useOptionalCreateRosterDraft();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdatePositionAndRoleParams) => {
      if (draft) {
        const current = draft.positions.find(
          (position) => position.id === params.position.id
        );
        draft.editSeat({
          id: params.position.id,
          name: params.position.name,
          reportsTo: current?.parent_id,
          isWorkgroup: current?.is_workgroup,
        });
        return {};
      }
      const response = await axios.post(
        apiConfig.apiGateway.incidentPositionAndRole,
        params
      );
      return response.data;
    },
    onSuccess: (data, variables) => {
      if (draft) return;
      queryClient.invalidateQueries({
        queryKey: keys.byPosition(variables.incidentId, variables.position.id),
      });
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.data?.ERROR || 'Failed to update position and role'
      );
    },
  });
};
